import { render, staticRenderFns } from "./Story.vue?vue&type=template&id=59b2a886&scoped=true&"
import script from "./Story.vue?vue&type=script&lang=js&"
export * from "./Story.vue?vue&type=script&lang=js&"
import style0 from "./Story.vue?vue&type=style&index=0&id=59b2a886&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b2a886",
  null
  
)

export default component.exports